import { ISanPhamPhamViActions } from "../../action-types/san-pham/ISanPhamPhamViActionType";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ISanPhamPhamViReducer } from "../../reducer-model/san-pham/ISanPhamPhamViReducer";

const iniState: ISanPhamPhamViReducer = {
    status: eReducerStatusBase.is_not_initialization,
    sanPhamPhamViList: []
}

export const sanPhamPhamViReducer = (state: ISanPhamPhamViReducer = iniState, action: ISanPhamPhamViActions): ISanPhamPhamViReducer => {
    switch (action.type) {
        case "SAN_PHAM_PHAM_VI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "SAN_PHAM_PHAM_VI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                sanPhamPhamViList: action.payload
            }
        case "SAN_PHAM_PHAM_VI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SAN_PHAM_PHAM_VI_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                sanPhamPhamViEditing: action.payload
            }
        case "SAN_PHAM_PHAM_VI_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "SAN_PHAM_PHAM_VI_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "SAN_PHAM_PHAM_VI_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "SAN_PHAM_PHAM_VI_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SAN_PHAM_PHAM_VI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "SAN_PHAM_PHAM_VI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "SAN_PHAM_PHAM_VI_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
}
